export enum ProductType {
  ONE_PIECE = "1pc",
  TWO_PIECE = "2pc",
  THREE_PIECE = "3pc",
}
